import { useQuery } from '@tanstack/react-query';
import type { Case } from '@casetrace/shared';
import { listMyCases, type MyCase } from '../lib/callables';

export function useMyCases() {
  return useQuery<MyCase[]>({
    queryKey: ['cases'],
    queryFn: listMyCases,
  });
}

export function useCases() {
  const query = useMyCases();
  return {
    ...query,
    data: query.data?.map((item) => item.case) as Case[] | undefined,
  };
}

export function useCaseRole(caseId: string | undefined) {
  const query = useMyCases();
  return {
    ...query,
    data: caseId ? query.data?.find((item) => item.case.id === caseId)?.role : undefined,
  };
}
